import React from 'react';
import {Card} from "antd";
import Mover from "./upload-buttons/popover-items/Mover";
import Stamper from "./upload-buttons/popover-items/Stamper";
import Deleter from "./upload-buttons/popover-items/Deleter";
import StatusChanger from "./upload-buttons/popover-items/StatusChanger";
import Excluder from "./upload-buttons/popover-items/Excluder";
import Rejector from "./upload-buttons/popover-items/Rejector";
import AskForMoreUploads from "./AskForMoreUploads";
import ExternalPdffer from "./ExternalPdffer";
import ReasonForAdvisorReview from "./upload-buttons/popover-items/ReasonForAdvisorReview";
import useMortgageUploadService from "../../../../../../../providers/mortgage/useMortgageUploadService";
import ButtonAsync from "../../../../../../elements/ButtonAsync";
function MiniCard({children, bg='#e5e5e5'}) {
    return <Card style={{backgroundColor: bg}} styles={{body: {padding: 6}}}>
        <div className="d-col gap-6">  {children} </div>
    </Card>
}
function UploadedFileStatus({section, uploadId, onConverted}) {
    const upload = section.uploads.find(u => u.id === uploadId).props.upload;
    const uploadService = useMortgageUploadService()

    const compress = async () => {
        await uploadService.compress(upload)
    }

    return (

            <div className="d-col w-100">
                <MiniCard>
                    <Mover uploadId={uploadId}/>
                </MiniCard>
                <div className="d-row gap-15 pt-6 w-100">
                    <div className="d-col gap-6">


                        <MiniCard>
                            <Stamper uploadId={uploadId}/>
                        </MiniCard>
                        <div className="mt-auto d-row j-between">
                            <Deleter uploadId={uploadId}/>
                            {/*<Scanner uploadId={uploadId} section={section}/>*/}


                        </div>

                    </div>
                    <div className="d-col gap-6">

                        {/*<MiniCard>*/}
                        {/*    <Renamer uploadId={uploadId} autoName={capitaliseWords(section.title)}/>*/}
                        {/*</MiniCard>*/}

                    </div>
                    <div className="d-col gap-6 grow">
                        <MiniCard>
                            {upload.fileSize > (2 * 1024 * 1024) && (
                                <div className="d-row j-between mt-15">

                                        <p className="m-0 text-danger ">This file seems very large  <ButtonAsync onClick={compress} >Compress</ButtonAsync></p>

                                </div>
                            )}
                            <StatusChanger uploadId={uploadId}/>
                            <ButtonAsync onClick={compress} >Compress / Flatten</ButtonAsync>
                        </MiniCard>
                        <div className="mt-auto">
                            <MiniCard>
                            <Excluder uploadId={uploadId}/>
                            </MiniCard>
                        </div>
                    </div>
                </div>

                {upload.status === 'REVIEWING' && (
                    <div className="mt-15">
                        <MiniCard>
                            <p className="m-0">What must the advisor look at on this upload?</p>
                            <ReasonForAdvisorReview uploadId={uploadId}/>
                        </MiniCard>
                    </div>
                )}
                {upload?.status === 'REJECTED' && (
                    <>
                    <div className="mt-15">
                        <MiniCard bg='#faad14'>
                            <Rejector uploadId={uploadId}/>
                        </MiniCard>
                    </div>
                        <div className="mt-15">
                            <MiniCard bg='#faad14'>
                                <AskForMoreUploads section={section}/>
                            </MiniCard>
                        </div>
                    </>
                )}
                {upload?.fileExtension?.toLowerCase() !== 'pdf' && (
                    <div className="mt-15">
                        <MiniCard>
                           <ExternalPdffer upload={upload} onConverted={onConverted}/>
                        </MiniCard>
                    </div>
                )}

            </div>


    );
}

export default UploadedFileStatus;
